import React, { Component } from 'react';
import '../css/CommissionDetails.css';
import moment from 'moment'
import Commissions from './Commissions';
import { CSVLink } from 'react-csv';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { isArray } from '@amcharts/amcharts4/core';

class CommissionDetails extends Component {
    state = {
        loading: true,
    }

    componentDidMount() {
        const commissionPayments = this.props.commissionPayments;

        const pastCommission = commissionPayments.reduce((pastCommission, obj) => {
            for (let name in obj) {
                const date = obj[name].startDate
                if (!pastCommission.includes(date)) { // Ensure distinct values
                    pastCommission.push(date);
                }
            }
            return pastCommission;
        }, []);



        const paramsStartDate = this.props.match.params.date? this.props.match.params.date.replace(/-/g, "/") : ""
        
        if (Array.isArray(pastCommission) && pastCommission.length > 0 && pastCommission.includes(paramsStartDate)){
            const formattedDate = moment(paramsStartDate, "DD/MM/YYYY").format("YYYY-MM-DD")
            // const formattedDate = moment(moment(new Date(currentStartDate[0])).format("DD-MM-YYYY")).format("YYYY-MM-DD");
            this.props.startLoadingCommissions(formattedDate);
        }
        // const current = Object.keys(commissionPayments).map(key => commissionPayments[key].Current);
        // const previous = Object.keys(commissionPayments).map(key => commissionPayments[key].Previous);
        // const currentStartDate = current.map(current => current.startDate);
        // const previousStartDate = previous.map(previous => previous.startDate);

        
        // if (this.props.match.params.status === 'due') {
        //     const formattedDate = moment(currentStartDate[0], "DD/MM/YYYY").format("YYYY-MM-DD")
        //     // const formattedDate = moment(moment(new Date(currentStartDate[0])).format("DD-MM-YYYY")).format("YYYY-MM-DD");
        //     this.props.startLoadingCommissions(formattedDate);
        // }
        // else {
        //     const formattedDate = moment(previousStartDate[0], "DD/MM/YYYY").format("YYYY-MM-DD")
        //     // const formattedDate = moment(moment(new Date(previousStartDate[0])).format("DD-MM-YYYY")).format("YYYY-MM-DD");
        //     this.props.startLoadingCommissions(formattedDate);
        // }
    }

    render() {

        const { t } = this.props
        const commissions = this.props.commissions;
        const commissionsList = !this.props.commissions ? [] : Object.keys(commissions).map(key => commissions[key]);
        const headers = [
            { label: "Group", key: "groupName" },
            { label: "From", key: "startDate" },
            { label: "To", key: "endDate" },
            { label: "adviser", key: "adviserName" },
            { label: "Scheme", key: "scheme" },
            { label: "mbrOrIrdNumber", key: "irdNumber" },
            { label: "Member", key: "memberName" },
            { label: "Amount", key: "amount" },
            { label: "Status", key: "status" }
        ]
        return (
            <div>
                <header className="adviserMenu" style={{ textAlgin: "left", paddingLeft: "15px", display: "inline-block" }}>{t('commission') + " " + t('details')}
                    <div style={{ paddingLeft: "15px", display: "inline-block" }}><button className="refresh" style={{ textAlign: "center" }}>
                        <CSVLink className="link" style={{ textDecoration: "none", paddingLeft: "5px", color: "white" }} 
                            filename="Commissions Payment.csv" data={commissionsList} headers={headers} className="commissionDetails">{t('adviserHomePage:export')}
                        </CSVLink></button></div>
                </header>
                <Commissions {...this.props} commissions={this.props.commissions} />
            </div>
        )
    }

}

CommissionDetails.propTypes = {
    commissionsList: PropTypes.array
}

export default withTranslation()(CommissionDetails);